// This file is generated by sync-zindex-layers. Do not edit manually.

export const z = {
    background: -1,
    base: 0,
    surface: 10,
    raised: 20,
    tabbar: 50,
    header: 100,
    topbar: 200,
    sidebar: 250,
    overlay: 300,
    modal: 400,
    dropdown: 500,
    toast: 600,
    tooltip: 700,
} as const;
